import { useTranslation } from "react-i18next";
import { ObjectImage } from "#src/common/system/Object";
import { RoleLabel } from "#src/common/helper/labels/RoleLabel";
import type { IBugBountyProgramMsspMember } from "#src/services/bugBounty/members";

const MsspMemberItem = ({
  member,
}: {
  member: IBugBountyProgramMsspMember;
}) => {
  const { t } = useTranslation("bugBounty", {
    keyPrefix: "page.bugBountyDetails.tab.members",
  });

  return (
    <div className="border border-grey rounded-md p-6 flex justify-between gap-2">
      <div className="flex items-center gap-2">
        <ObjectImage
          data={member.user?.avatar}
          className="h-11 w-11 min-w-[2.75rem] rounded-full"
        />
        <div>
          <div className="font-medium-16 flex gap-2 items-center">
            {member.user ? member.user.full_name : member.id}
            <div className="flex gap-1">
              {member.role === "security_manager" ? (
                <RoleLabel
                  name={t("label.securityManager")}
                  color={"bg-dark-blue"}
                />
              ) : null}
              {member.role === "pentester" ? (
                <RoleLabel name={t("label.pentester")} color={"bg-fire"} />
              ) : null}
            </div>
          </div>
          <span className="font-regular-14 text-primary">
            {"@" + (member.user ? member.user.username : member.id)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default MsspMemberItem;
